"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.format = void 0;

var _propertyTranslator = require("property-translator/propertyTranslator");

var _get = _interopRequireDefault(require("transmute/get"));

var format = function format(stage, _pipelineId, _pipelineLabel) {
  var defaultTicketPipeline = '0';
  var defaultDealPipeline = 'default';

  var pipelineId = _pipelineId || (0, _get.default)('pipelineId', stage);

  var pipelineLabel = _pipelineLabel || (0, _get.default)('pipelineLabel', stage);

  var text = (0, _get.default)('text', stage);
  var textTranslated = [defaultTicketPipeline, defaultDealPipeline].includes(pipelineId) ? (0, _propertyTranslator.propertyLabelTranslator)(text) : text;
  return pipelineLabel ? textTranslated + " (" + pipelineLabel + ")" : textTranslated;
};

exports.format = format;